module.exports = __webpack_public_path__ + "img/27.9b4c2313.png";